export default "__VITE_ASSET__DVOMD_Eb__"